<script>
  export default {
    name: 'ExhibitBox',
    props: {
      sinceSelf: {
        type: Boolean,
        default: false
      },
      visible: {
        type: Boolean,
        default: false
      },
      insText: {
        type: Array,
        default() {
          return ['展开', '收起']
        }
      }
    },
    data() {
      return {
        show: this.visible
      }
    },
    watch: {
      visible(newValue) {
        if (this.sinceSelf) return
        this.show = newValue
      }
    },
    methods: {
      toggle() {
        const {
          show,
          sinceSelf
        } = this
        if (sinceSelf) {
          const visible = !show
          this.show = visible
          this.$emit('toggle', visible)
        } else {
          this.$emit('toggle', show)
        }
      }
    }
  }
</script>

<template>
  <div class="exhibit-box">
    <div class="hd" @click="toggle">
      <div class="title">
        <slot name="title" />
      </div>
      <a href="javascript:;">
        <template v-if="show">
          <span>{{ insText[1] }}</span><i class="iconfont icon-arrows_up" />
        </template>
        <template v-else>
          <span>{{ insText[0] }}</span><i class="iconfont icon-arrows_down" />
        </template>
      </a>
    </div>
    <div class="bd">
      <slot name="immortal" />
      <slot v-if="show" />
    </div>
  </div>
</template>


<style scoped>
  .exhibit-box {
    >.hd {
      display: flex;
      padding: 15px;
      background-color: #fff;
      .title {
        flex: 1;
      }
      a {
        flex: 50px 0 0;
        color: #999;
        outline: none;
      }
      i {
        color: #ccc;
      }
    }
  }
</style>